/* eslint-disable react/prop-types, no-console */
import React, { memo } from 'react';

function Circle({ coordinates: [ y, x ], fill, ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1" height="1" x={x} y={y} {...props}>
      <circle data-e2e="circle" cx="12" cy="12" r="10" fill={fill} />
    </svg>
  );
}

export default memo(Circle);
